import { divide, multiply, subtract } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";

const TdsAmount = ({ bill, gst_charge, tds }) => {
  const finalVal = multiply(
    divide(tds, 100),
    subtract(Number(bill ?? 0), Number(gst_charge ?? 0))
  ).toFixed(2);
  return (
  <FormulaLayoutUI>

    <div style={{ marginBottom: "12px" }}>
      <strong style={{ fontSize: "15px" }}>TDS Amount Formula</strong>
    </div>

    <div
      style={{
        padding: "10px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        fontSize: "13px",
        marginBottom: "10px",
      }}
    >
      <div>
        TDS = (Miller Bill Amount − Miller GST Charge) × TDS %
      </div>

      <div style={{ marginTop: "6px", color: "#555" }}>
        = ({bill} − {gst_charge}) × {tds}%
      </div>

      <div style={{ marginTop: "6px" }}>
        = {Number(bill - gst_charge).toFixed(2)} × {tds}%
      </div>

      <div
        style={{
          marginTop: "10px",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        TDS Amount: ₹ {Number(finalVal).toFixed(3)} /-
      </div>
    </div>
  </FormulaLayoutUI>
);

};

export default TdsAmount;
